/**
 * @generated SignedSource<<ba408534e18d50a62a21df424fad0b7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilizationBarChartComponent_viewer$data = {
  readonly insightComponentsData: {
    readonly utilizationBarChart: {
      readonly data: ReadonlyArray<{
        readonly id: string;
        readonly personName: string | null;
        readonly availableHours: number | null;
        readonly projectHours: number | null;
        readonly idleHours: number | null;
        readonly registeredHours: number | null;
        readonly plannedCardHours: number | null;
        readonly timeOffHours: number | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "utilizationBarChartComponent_viewer";
};
export type utilizationBarChartComponent_viewer$key = {
  readonly " $data"?: utilizationBarChartComponent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"utilizationBarChartComponent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dateCriteria"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "roleIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "utilizationBarChartComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "componentId",
              "variableName": "componentId"
            },
            {
              "kind": "Variable",
              "name": "dateCriteria",
              "variableName": "dateCriteria"
            },
            {
              "kind": "Variable",
              "name": "labelIds",
              "variableName": "labelIds"
            },
            {
              "kind": "Variable",
              "name": "personIds",
              "variableName": "personIds"
            },
            {
              "kind": "Variable",
              "name": "roleIds",
              "variableName": "roleIds"
            },
            {
              "kind": "Variable",
              "name": "teamIds",
              "variableName": "teamIds"
            }
          ],
          "concreteType": "UtilizationBarChart",
          "kind": "LinkedField",
          "name": "utilizationBarChart",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UtilizationBarChartElement",
              "kind": "LinkedField",
              "name": "data",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "personName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "idleHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registeredHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "plannedCardHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "timeOffHours",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "06b8561e2ffff79e20e89b6f7647f339";

export default node;
